import {useEffect, useState} from "react";
import moment from "moment/moment";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button} from "@mui/material";
import * as React from "react";

export default function CampaignsSendNotificationNewCampaigns({row,setLoading}) {

    const [show,setShow] = useState(false);
    const [remindshow,setremindShow] = useState(false);

    useEffect(() => {
        setShow(!row.campaign_sent_at && moment(row.created_at).format('YYYY-MM-DD') > '2022-08-20');
        setremindShow(!row.campaign_reminded_at && moment(row.created_at).format('YYYY-MM-DD') > '2022-08-20');
    }, []);

    function sendEmail() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/notification/notify/new/')+row.id,{}
        ).then(() => setLoading(true))
    }

    function sendReminder() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/notification/notify/remind/')+row.id,{}
        ).then(() => setLoading(true))
    }

    if(!show && !remindshow) return "Notification already sent";
    
    if (!show) {
        return (
            <Button variant={"contained"} size={"small"} onClick={sendReminder}  style={{ backgroundColor: "red", color: "white" }}>
                Remind
            </Button>
        );
    }

    

    return (
        <Button variant={"contained"} size={"small"} onClick={sendEmail}>
            Notify
        </Button>
    );
    
}
